import {
  formatDateMMddYYYY,
  MetricProgressBar,
  toProgressSegments,
} from '../utils/utils';
import {
  ParentConfidenceAssessment,
  ProgressPortraitMetrics,
} from '../model/ProgressPortrait';
import { CellData, ProgressBar } from './ProgressBar';
import { CellTooltip, TooltipItem } from './CellTooltip';

const extractPcsData = (progressPortraitMetrics: ProgressPortraitMetrics) =>
  progressPortraitMetrics.pcs ?? [];

const toCellData = (pcs: ParentConfidenceAssessment): CellData => {
  const tooltip = <ParentConfidenceTooltip pcs={pcs} />;
  return {
    level: 'NA',
    label: 'View',
    tooltip,
  };
};

const shortenResponse = (response: string) => {
  if (response === 'Received no parent education/training') {
    return 'Received no training';
  }

  return response;
};

export const ParentConfidenceMetric = ({
  progressPortraitMetrics,
}: MetricProgressBar) => {
  const segments = toProgressSegments(
    progressPortraitMetrics,
    extractPcsData,
    toCellData,
  );
  return <ProgressBar segments={segments} />;
};

const ParentConfidenceTooltip = ({
  pcs,
}: {
  pcs: ParentConfidenceAssessment;
}) => {
  const scoreItem: TooltipItem[] =
    pcs.survey_not_completed__c ||
    pcs.parent_Confidence_Survey__c === 'Initial Assessment'
      ? []
      : [
          {
            label: 'Confidence Score:',
            value: pcs.parent_Confidence_Score__c,
          },
        ];
  const extraInfo: TooltipItem[] =
    pcs.parent_Confidence_Survey__c === 'Initial Assessment'
      ? [
          {
            label: 'I feel confident teaching my child:',
            value: shortenResponse(pcs.teach_New_Skills__c),
          },
          {
            label: "I can manage my child's behavior:",
            value: shortenResponse(pcs.manage_Behavior__c),
          },
        ]
      : [
          {
            label: 'I learned from my child’s treatment:',
            value: shortenResponse(pcs.helpful_Training__c),
          },
          {
            label: 'I feel confident teaching my child:',
            value: shortenResponse(pcs.teach_New_Skills__c),
          },
          {
            label: "I can manage my child's behavior:",
            value: shortenResponse(pcs.manage_Behavior__c),
          },
          {
            label: 'What I have learned is positive for me and my family:',
            value: shortenResponse(pcs.positive_Effect__c),
          },
        ];
  const info: TooltipItem[] = [
    {
      label: 'Parent Confidence Survey Date:',
      value: formatDateMMddYYYY(pcs.assessment_Date__c),
    },
    ...scoreItem,
    {
      label: 'Respondent:',
      value: pcs.name_Of_Respondent__c,
    },
    ...extraInfo,
  ];
  return <CellTooltip info={info} />;
};
